import { IconProps } from '.';

const PauseIcon = ({ color, customClasses }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      className={customClasses}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 6V17H8.5V6H7ZM15 6V17H16.5V6H15Z"
        fill={color || '#ebece9'}
      />
    </svg>
  );
};

export default PauseIcon;
